var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7301_27149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7727 11.25H1.22727C0.964773 11.25 0.75 11.0352 0.75 10.7727V1.22727C0.75 0.964773 0.964773 0.75 1.22727 0.75C1.48977 0.75 1.70455 0.964773 1.70455 1.22727V9.81818C1.70455 10.0807 1.91932 10.2955 2.18182 10.2955H10.7727C11.0352 10.2955 11.25 10.5102 11.25 10.7727C11.25 11.0352 11.0352 11.25 10.7727 11.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22725 8.38638C1.04111 8.20025 1.04111 7.89957 1.22725 7.71343L3.75202 5.18866C3.93816 5.00252 4.23884 5.00252 4.42498 5.18866L5.42248 6.18616C5.60861 6.37229 5.90929 6.37229 6.09543 6.18616L10.0997 2.18184C10.2859 1.9957 10.5866 1.9957 10.7727 2.18184C10.9588 2.36797 10.9588 2.66866 10.7727 2.85479L6.1002 7.52729C5.91407 7.71343 5.61338 7.71343 5.42725 7.52729L4.42975 6.52979C4.24361 6.34366 3.94293 6.34366 3.75679 6.52979L1.90498 8.38161C1.71884 8.56775 1.41816 8.56775 1.23202 8.38161L1.22725 8.38638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7727 5.04544C10.5102 5.04544 10.2954 4.83067 10.2954 4.56817V3.13635C10.2954 2.87385 10.0806 2.65907 9.81815 2.65907H8.38633C8.12383 2.65907 7.90906 2.4443 7.90906 2.1818C7.90906 1.9193 8.12383 1.70453 8.38633 1.70453H10.7727C11.0352 1.70453 11.25 1.9193 11.25 2.1818V4.56817C11.25 4.83067 11.0352 5.04544 10.7727 5.04544Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7301_27149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 10.5,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.84bfa67bf907b26af6bdc1739ad74dc5.svg";
export { ForwardRef as ReactComponent };